export const Text = {
  sizes: {
    xs: () => ({
      fontSize: 'xs',
    }),
    sm: () => ({
      fontSize: 'sm',
    }),
    md: () => ({
      fontSize: 'md',
    }),
    lg: () => ({
      fontSize: 'lg',
    }),
    xl: () => ({
      fontSize: 'xl',
    }),

    // font size sm(12px) with all the bold variants
    'xs-regular': () => ({
      fontSize: 'xs',
      fontWeight: 450,
    }),
    'xs-medium': () => ({
      fontSize: 'xs',
      fontWeight: 550,
    }),
    'xs-semi-bold': () => ({
      fontSize: 'xs',
      fontWeight: 650,
    }),

    // font size sm(14px) with all the bold variants
    'sm-regular': () => ({
      fontSize: 'sm',
      fontWeight: 450,
    }),
    'sm-medium': () => ({
      fontSize: 'sm',
      fontWeight: 550,
    }),
    'sm-semi-bold': () => ({
      fontSize: 'sm',
      fontWeight: 650,
    }),
    'sm-bold': () => ({
      fontSize: 'sm',
      fontWeight: 650,
    }),

    // font size md(16px) with all the bold variants
    'md-regular': () => ({
      fontSize: 'md',
      fontWeight: 450,
    }),
    'md-medium': () => ({
      fontSize: 'md',
      fontWeight: 550,
    }),
    'md-semi-bold': () => ({
      fontSize: 'md',
      fontWeight: 650,
    }),
    'md-bold': () => ({
      fontSize: 'md',
      fontWeight: 650,
    }),

    // font size lg(18px) with all the bold variants
    'lg-regular': () => ({
      fontSize: 'lg',
      fontWeight: 450,
    }),
    'lg-medium': () => ({
      fontSize: 'lg',
      fontWeight: 550,
    }),
    'lg-semi-bold': () => ({
      fontSize: 'lg',
      fontWeight: 650,
    }),
    'lg-bold': () => ({
      fontSize: 'lg',
      fontWeight: 650,
    }),

    // font size xl(20px) with all the bold variants
    'xl-regular': () => ({
      fontSize: 'xl',
      fontWeight: 450,
    }),
    'xl-medium': () => ({
      fontSize: 'xl',
      fontWeight: 550,
    }),
    'xl-semi-bold': () => ({
      fontSize: 'xl',
      fontWeight: 650,
    }),
    'xl-bold': () => ({
      fontSize: 'xl',
      fontWeight: 650,
    }),

    // font size xxl(22px) with all the bold variants
    'xxl-regular': () => ({
      fontSize: 'xxl',
      fontWeight: 450,
    }),
    'xxl-medium': () => ({
      fontSize: 'xxl',
      fontWeight: 550,
    }),
    'xxl-semi-bold': () => ({
      fontSize: 'xxl',
      fontWeight: 650,
    }),
    'xxl-bold': () => ({
      fontSize: 'xxl',
      fontWeight: 650,
    }),

    // font size xxxl(24px) with all the bold variants
    'xxxl-regular': () => ({
      fontSize: 'xxxl',
      fontWeight: 450,
    }),
    'xxxl-medium': () => ({
      fontSize: 'xxxl',
      fontWeight: 550,
    }),
    'xxxl-semi-bold': () => ({
      fontSize: 'xxxl',
      fontWeight: 650,
    }),
    'xxxl-bold': () => ({
      fontSize: 'xxxl',
      fontWeight: 650,
    }),
  },

  variants: {
    primary: (props) => ({
      color:
        props.colorMode === 'dark' ? 'dark.text-primary' : 'light.text-primary',
    }),
    muted: (props) => ({
      color:
        props.colorMode === 'dark' ? 'dark.text-secondary' : 'secondary-500',
    }),
    // custom variants
    pageHeader: () => ({
      //heading 1
      fontSize: 'xl', //20px
      fontWeight: 650,
      color: 'secondary-900',
    }),
    moduleHeader: () => ({
      //heading 2
      fontSize: 'md', //16px
      fontWeight: 650,
      color: 'secondary-900',
    }),
    textDefault: () => ({
      //paragraph
      fontSize: 'sm', //14px
      fontWeight: 450,
      color: 'secondary-700',
    }),
    cellTitle: () => ({
      // heading 3
      fontSize: 'sm', //14px
      fontWeight: 650,
      color: 'primary-900',
    }),
    tableHeader: () => ({
      fontSize: 'sm', //14px
      fontWeight: 650,
      color: 'secondary-900',
      textTransform: 'uppercase',
    }),
  },
  defaultProps: {
    variant: 'primary',
    size: 'sm',
  },
};
